module.exports = __webpack_public_path__ + "img/galeria-especie-exotica-11.1b614afd.jpg";